import centeredHeroTemplate from './centeredHero/index.js'
import { defaultTemplateParams as centeredHeroTemplateParams } from './centeredHero/params.js'
import centeredHeroPreview from './centeredHero/preview.jpg'
import centeredHeroSections from './centeredHero/sections.js'
import centeredHeroCardImage from './centeredHero/template.png'
import defaultTemplate from './default/index.js'
import { defaultTemplateParams } from './default/params.js'
import defaultPreview from './default/preview.jpg'
import defaultSections from './default/sections.js'
import defaultCardImage from './default/template.png'
import editorialEventTemplate from './editorialEvent/index.js'
import { defaultTemplateParams as editorialEventTemplateParams } from './editorialEvent/params.js'
import editorialEventPreview from './editorialEvent/preview.jpg'
import editorialEventSections from './editorialEvent/sections.js'
import editorialEventCardImage from './editorialEvent/template.png'
import resortDiscoveryTemplate from './resortDiscovery/index.js'
import { defaultTemplateParams as resortDiscoveryTemplateParams } from './resortDiscovery/params.js'
import resortDiscoveryPreview from './resortDiscovery/preview.jpg'
import resortDiscoverySections from './resortDiscovery/sections.js'
import resortDiscoveryCardImage from './resortDiscovery/template.png'
import twoColumnTemplate from './twoColumn/index.js'
import { defaultTemplateParams as twoColumnTemplateParams } from './twoColumn/params.js'
import twoColumnPreview from './twoColumn/preview.jpg'
import twoColumnSections from './twoColumn/sections.js'
import twoColumnCardImage from './twoColumn/template.png'

const LEGACY_TEMPLATE_KEY_MAP = {
  luxuryInvite: 'default',
  personalNote: 'default',
  dualCta: 'default',
  premiumDirect: 'default',
  introKickerBody: 'default',
  galleryShowcase: 'default',
  splitHighlight: 'twoColumn',
  wideHero: 'default',
  heroSlideshow: 'default',
  bodyThenGallery: 'default',
  stackedStory: 'editorialEvent',
  minimalDirect: 'resortDiscovery',
  zigZagColumns: 'twoColumn',
  discoverLinks: 'resortDiscovery',
  galleryWithCaptions: 'default',
  lifestyleBreak: 'default',
  socialProof: 'default',
  experienceCards: 'resortDiscovery'
}

// Production shell layouts — each entry must use editor sections with matching mjml-* css-class names.
export const availableTemplates = {
  default: {
    name: 'Default Template',
    description: 'Clean and modern email template with hero image',
    template: defaultTemplate,
    params: defaultTemplateParams,
    sections: defaultSections,
    preview: defaultPreview,
    cardImage: defaultCardImage
  },
  resortDiscovery: {
    name: 'Resort Discovery',
    description: 'Silverado-style centered invite, ghost discover buttons, four-up gallery, and light footer',
    template: resortDiscoveryTemplate,
    params: resortDiscoveryTemplateParams,
    sections: resortDiscoverySections,
    preview: resortDiscoveryPreview,
    cardImage: resortDiscoveryCardImage
  },
  editorialEvent: {
    name: 'Editorial Event',
    description: 'Terranea-style arched hero, pill CTA, and stacked editorial story blocks with navy footer',
    template: editorialEventTemplate,
    params: editorialEventTemplateParams,
    sections: editorialEventSections,
    preview: editorialEventPreview,
    cardImage: editorialEventCardImage
  },
  twoColumn: {
    name: 'Two Column Template',
    description: 'Two column layout for better content organization',
    template: twoColumnTemplate,
    params: twoColumnTemplateParams,
    sections: twoColumnSections,
    preview: twoColumnPreview,
    cardImage: twoColumnCardImage
  },
  centeredHero: {
    name: 'Centered Hero',
    description: 'Centered logo, headline, and call-to-action below the hero image',
    template: centeredHeroTemplate,
    params: centeredHeroTemplateParams,
    sections: centeredHeroSections,
    preview: centeredHeroPreview,
    cardImage: centeredHeroCardImage
  }
}

export const resolveEditorTemplateKey = (templateName = 'default') => {
  const legacyKey = LEGACY_TEMPLATE_KEY_MAP[templateName]
  const normalizedName = legacyKey || templateName

  return availableTemplates[normalizedName] ? normalizedName : 'default'
}

export const getTemplate = (templateName = 'default') => {
  return availableTemplates[resolveEditorTemplateKey(templateName)]
}

const SHELL_TEMPLATE_DISPLAY_ORDER = [
  'default',
  'resortDiscovery',
  'editorialEvent',
  'twoColumn',
  'centeredHero'
]

export const getTemplateNames = () => {
  const keys = Object.keys(availableTemplates)
  const ordered = SHELL_TEMPLATE_DISPLAY_ORDER.filter(key => keys.includes(key))
  const remainder = keys.filter(key => !ordered.includes(key))

  return [...ordered, ...remainder]
}

export const getTemplateOptions = () => {
  return getTemplateNames().map(key => {
    const template = availableTemplates[key]

    return {
      value: key,
      label: template.name,
      description: template.description,
      preview: template.preview,
      cardImage: template.cardImage
    }
  })
}
